export default "__VITE_ASSET__c152dd01__"